export const SAMPLE_ROLE = 'Senior Developer — Frontend Foundations';

export const SAMPLE_APPLICATION = `Cover letter

To the Frontend Foundations team,

I'm applying for the Senior Developer — Frontend Foundations role. The platform-engineering shape of what your team is doing — Module Federation rollout, modern build tooling, design system stewardship — maps directly onto what I've been doing for the last two and a half years at LendCircle.

At LendCircle (a Vancouver-based fintech), I led our Module Federation migration across three product teams. We landed in a place where teams ship independently while consuming shared infrastructure. Getting the deployment topology right took longer than the technical setup; in retrospect, I'd have invested more time in adoption documentation upfront.

A specific question I have for the Foundations team: how did you arrive at webpack vs. rspack for Lantern? I migrated our LendCircle build pipeline from webpack to rspack last year and saw significant CI time reduction (~40%), but I'm aware the migration trade-offs differ depending on the codebase shape and the consumer surface area. Curious about your thinking on it.

I work with AI tools daily — Cursor and Claude Code — and have written publicly about the practice (a 4-part series on my blog at marcuschen.dev). I think there's still a lot to figure out about AI-assisted platform engineering, and I'd want to be on a team thinking about it actively.

Looking forward to the conversation.

Marcus Chen

—

Marcus Chen
Vancouver, BC | marcus.chen.dev@example.com | github.com/marcuschen-dev | marcuschen.dev

Summary
Frontend platform engineer with 8 years of experience across fintech and SaaS. Recent focus: Module Federation migration, build tooling modernization, and AI-assisted development practice. Currently Lead Frontend Engineer at LendCircle.

Experience

Lead Frontend Engineer — LendCircle | 2022–Present
Vancouver-based fintech platform serving Canadian SMBs.
- Led Module Federation migration across three product teams. Designed shared-dependency strategy, deployment topology, and host/shell communication patterns. Teams now ship independently against shared infrastructure.
- Migrated webpack → rspack across all four production apps. Reduced CI build times by ~40%, improved local dev startup by ~60%.
- Maintain the company's frontend platform: shared component library, integration utilities, build config, observability hooks (Sentry, Datadog).
- Mentor 4 mid-level engineers; lead architecture reviews for the platform team.

Senior Frontend Engineer — Sortable | 2019–2022
Ad-tech analytics platform serving 200+ enterprise customers.
- Built dashboard infrastructure consumed by 6 product teams.
- Authored shared internal component library; led migration from CRA to Vite across primary product surfaces.

Frontend Engineer — TwoTap | 2017–2019
Embedded checkout SDK for 50+ ecommerce merchants.
- Built customer-facing checkout flows integrated as a third-party SDK.
- Optimized bundle size and load performance for partner merchants in performance-sensitive regions.

Skills
JavaScript / TypeScript, React, Module Federation, webpack, rspack, Vite, Node.js, GraphQL, REST, Sentry, Datadog, GitHub Actions, AWS, Cursor, Claude Code, MCP

Education
McGill University — B.Eng., Software Engineering | 2013–2017

Public artifacts
- github.com/marcuschen-dev — active commits across personal and open-source repos
- marcuschen.dev — engineering blog, including 4-part series "How I use AI in frontend development"
- Spoke at FrontendConf Toronto 2023 — "Module Federation in Practice: Lessons from a 3-Team Migration"

Authorization
Canadian citizen. Authorized to work in Canada.`;
